import axios from "axios";
import { PHYLLO_TOKEN } from "./constants";
import { api, authApi, getCreds } from "./axios";

const URL_GET_ALL_ACCOUNTS = "v1/internal/accounts";
const URL_GET_ALL_PROFILES = "v1/profiles";
const URL_GET_AUDIENCE_DEMOGRAPHICS = "v1/audience";
const URL_GET_ALL_INCOME = "v1/income/accounts";
const URL_GET_ALL_CONTENT = "v1/social/contents";
const URL_GET_ALL_CONTENT_GROUPS = "v1/social/content-groups";
const URL_GET_CONTENT_COMMENTS = "v1/social/comments"
const URL_POST_FILE_UPLOAD_URL = "v1/internal/file-upload-url";
const URL_POST_PUBLISH = "v1/social/contents/publish";
const URL_GET_PUBLISH_STATUS = "v1/social/contents/publish";

const URL_Login = "v1/phyllodemoapp/login";
const URL_Signup = "v1/phyllodemoapp/signup";

const getCommonHeader = async () => {
  const token = sessionStorage.getItem(PHYLLO_TOKEN);
  let headers = {};
  headers["Authorization"] = `Bearer ${token}`;
  headers["sdk-type"] = "WEB";
  headers["sdk-version"] = "1.0";
  headers["content-type"] = "application/json";
  return headers;
};

export const getAllAccounts = async () => {
  const creds = getCreds();
  try {
    const headers = await getCommonHeader();
    const response = await axios.get(
      creds.base_url + URL_GET_ALL_ACCOUNTS + "?limit=100",
      {
        headers: headers,
      }
    );
    return response;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getProfileInfo = async (id) => {
  const creds = getCreds();
  try {
    const response = await api().get(
      creds.base_url + `${URL_GET_ALL_PROFILES}?account_id=${id}`
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getAudienceDemographics = async (id) => {
  const creds = getCreds();
  try {
    const headers = await getCommonHeader();
    const response = await api().get(
      creds.base_url + `${URL_GET_AUDIENCE_DEMOGRAPHICS}?account_id=${id}`
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};
export const getIncome = async (id) => {
  const creds = getCreds();
  try {
    const response = await api().get(
      creds.base_url + `${URL_GET_ALL_INCOME}/${id}`
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getContent = async (id) => {
  const creds = getCreds();
  try {
    const response = await api().get(
      creds.base_url + `${URL_GET_ALL_CONTENT}?account_id=${id}`
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getContentGroup = async (id) => {
  const creds = getCreds();
  try {
    const response = await api().get(
      creds.base_url + `${URL_GET_ALL_CONTENT_GROUPS}?account_id=${id}`
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getContentComments = async (account_id, content_id) => {
  const creds = getCreds();
  try {
    const response = await api().get(
      creds.base_url + `${URL_GET_CONTENT_COMMENTS}?account_id=${account_id}&content_id=${content_id}`
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const login = async (body) => {
  const creds = getCreds();
  try {
    // const headers = await getCommonHeader();
    let headers = {};
    // headers["Authorization"] = `Bearer ${token}`;
    headers["sdk-type"] = "WEB";
    headers["sdk-version"] = "1.0";
    headers["content-type"] = "application/json";
    const response = await authApi().post(
      creds.base_url + `${URL_Login}`,
      body,
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const signup = async (body) => {
  const creds = getCreds();
  try {
    // const headers = await getCommonHeader();
    let headers = {};
    // headers["Authorization"] = `Bearer ${token}`;
    headers["sdk-type"] = "WEB";
    headers["sdk-version"] = "1.0";
    headers["content-type"] = "application/json";
    const response = await authApi().post(
      creds.base_url + `${URL_Signup}`,
      body,
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getPreSignedURL = async (workplatformId) => {
  const creds = getCreds();
  try {
    const headers = await getCommonHeader();
    const response = await axios.post(
      creds.base_url + URL_POST_FILE_UPLOAD_URL,
      {
        work_platform_id: workplatformId,
      },
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const postMedia = async (uploadURL, file, setProgress) => {
  const creds = getCreds();
  const onUploadProgress = (event) => {
    const percentage = Math.round((100 * event.loaded) / event.total);
    setProgress(percentage);
  };

  try {
    const headers = await getCommonHeader();
    const response = await axios.put(uploadURL, file, {
      headers: {
        "Content-Type": file.type,
        "x-amz-acl": "public-read",
      },
      onUploadProgress,
    });
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const publish = async (payload) => {
  const creds = getCreds();
  try {
    const headers = await getCommonHeader();
    const response = await api().post(
      creds.base_url + URL_POST_PUBLISH,
      payload
    );
    return response;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getPublishStatus = async (id) => {
  const creds = getCreds();
  try {
    const headers = await getCommonHeader();
    const response = await api().get(
      creds.base_url + URL_GET_PUBLISH_STATUS + "/" + id
    );
    console.log(response.data.status);
    return response.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};
